import { go, Model } from 'oderon-vue'
import { brDec } from 'oderon-commons/src/formatters'
import grid from 'oderon-commons/src/grid'
import { preProcessSpec } from 'oderon-commons/src/tables'
import utils from 'oderon-commons/src/utils'

export const Technician = new Model('/technicians')

Technician.patch = (id, body) => go.patch(`/technicians/${id}`, body)

const fullSpec = preProcessSpec({
  defaultSortable: true,
  columns: [
    { t: 'ID|', d: 'id', color: '#ccc' },
    {
      t: 'Nome',
      code: 'name',
      d: row => {
        if (row.deletedAt != null) return { value: row.name, strike: true }
        else return row.name
      }
    },
    { t: 'Valor Instalação|', d: 'installValue', f: brDec },
    { t: 'Valor Remoção|', d: 'removeValue', f: brDec },
    { t: 'Organizações', d: 'orgLabels' },
    { t: 'Crachás', d: x => (x.cards || []).map(c => c.serial).join(', ') }
  ]
})

// O get /id é sobrescrito para inicializar algumas props.
Technician.findById = async function(id) {
  let row = await go.get(`/technicians/${id}`)
  if (row.cards == null) row.cards = []
  if (row.orgIds == null) row.orgIds = []
  return row
}

// Simula um get /grid/spec
Technician.getGridSpec = () => {
  return fullSpec
}

// Simula um get /grid
Technician.getGrid = async function({
  containingId = null,
  includeInactive = false,
  limit = 20,
  offset = 0,
  keywords,
  order = 'name asc'
}) {
  let allOrgs = await go.get('/organizations', { mini: true })
  let allTechs = await Technician.findAll({ includeInactive: true })

  for (let x of allTechs) {
    let labels = (x.orgIds || []).map(id => {
      let org = allOrgs.find(x => x.id == id)
      return org ? org.label : null
    })

    x.orgLabels = labels.join(', ')
  }

  let rows = utils.orderBy(allTechs, utils.order(order))
  if (!includeInactive) rows = rows.filter(x => x.deletedAt == null)
  if (keywords != null)
    rows = rows.filter(x => {
      return utils.matchAnyLike(keywords, x.name, JSON.stringify(x.cards))
    })

  if (containingId != null) {
    // O resultado é o índice do primeiro elemento da página
    // (de tamanho "limit") que conterá o valor solicitado.
    let idx = rows.findIndex(r => r.id == containingId)
    if (idx == -1) offset = 0
    else offset = Math.floor(idx / limit) * limit
  }

  let slice = rows.slice(offset, offset + limit)

  return grid.generateWebGrid({
    rows: slice,
    spec: fullSpec,
    count: rows.length,
    offset
  })
}
